export default {
  common: {
    loading: 'กำลังโหลด',
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    back: 'ย้อนกลับ',
    copy: 'คัดลอก',
    delete: 'ลบ',
    copySuccess: 'คัดลอกสำเร็จ',
    editSuccess: 'แก้ไขสำเร็จ',
    deleteSuccess: 'ลบสำเร็จ',
    modifySuccess: 'อัปเดตสำเร็จ',
    cannotBeEmpty: 'ห้ามเว้นว่าง',
    noContent: 'ไม่มีเนื้อหา',
    noData: 'ไม่มีข้อมูล',
    noMoreData: 'ไม่มีข้อมูลเพิ่มเติม',
    iKnow: 'รับทราบ',
    selectService: 'เลือกผู้ให้บริการ',
    sendSuccess: 'ส่งสำเร็จ',
  },
  billHome: {
    recharge: 'บริการเติมเงิน/ชำระบิล',
    coupon: 'คูปอง',
    rechargeNow: 'เติมเงินตอนนี้',
    cost: 'ค่าโทร',
    flow: 'อินเทอร์เน็ต',
    rechargeNotice: 'ข้อควรรู้ก่อนเติมเงิน',
    rechargeCost: 'เติมค่าโทร',
    rechargeFlow: 'เติมเน็ต',
    rechargeAmount: 'จำนวนเงินที่เติม',
    rechargePackage: 'แพ็กเกจเติมเงิน',
    discount: 'ส่วนลดแล้ว',
    confirmTxt: 'ยืนยันความถูกต้อง',
    confirmTxt1: 'รับทราบแล้ว',
    actualPayment: 'ยอดที่ต้องชำระ',
    selectCoupon: 'เลือกคูปอง',
    useRule: 'เงื่อนไขการใช้',
    availableCoupon: 'คูปองที่ใช้ได้',
    unavailableCoupon: 'คูปองที่ใช้ไม่ได้',
    noAvailableCoupon: 'ยังไม่มีคูปองที่ใช้ได้',
    selectPhone: 'เลือกเบอร์โทร',
    pleaseInputPhone: 'กรุณาใส่เบอร์โทรศัพท์',
    couponCount: 'คูปองที่ใช้ได้',
    pleaseInputCorrectPhone: 'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
    pleaseSelectPackage: 'กรุณาเลือกแพ็กเกจเติมเงิน',
  },
  accountManage: {
    title: 'จัดการบัญชี',
    edit: 'แก้ไข',
    deleteConfirm: 'ยืนยันการลบ',
  },
  rechargeDetail: {
    title: 'รายละเอียดการชำระเงิน',
    continuePay: 'ดำเนินการชำระเงินต่อ',
  },
  feesExpense: {
    title: 'ประวัติการชำระเงิน',
    recharge: 'ค่าโทรศัพท์',
    electricity: 'ค่าไฟฟ้า',
    internet: 'ค่าอินเทอร์เน็ต',
    water: 'ค่าน้ำ',
    photo: 'ถ่ายรูป',
    complete: 'เสร็จสิ้น',
    manage: 'จัดการ',
    allSelect: 'เลือกทั้งหมด',
    selected: 'รายการที่เลือก',
    deleteConfirm: 'ลบ',
    deleteRecord: 'รายการชำระเงินนี้หรือไม่?',
    noDataAction: 'ไม่มีข้อมูลให้จัดการ',
    pleaseSelect: 'กรุณาเลือกรายการที่ต้องการลบ',
    feesNotice: 'ข้อควรรู้ก่อนชำระเงิน',
  },
  formCom: {
    upload: 'คลิกเพื่ออัปโหลด',
    saveAccount: 'บันทึกหรืออัปเดตบัญชีที่มีอยู่',
    createOrder: 'สร้างคำสั่งซื้อ',
    rechargeIng: 'กำลังเติมเงิน',
    rechargeNow: 'เติมเงินตอนนี้',
    serviceProvider: 'ผู้ให้บริการ',
    billImage: 'รูปบิล',
    returnSelect: 'กลับไปเลือกใหม่',
    electricity: 'ค่าน้ำค่าไฟ',
    internet: 'ค่าอินเทอร์เน็ต',
    water: 'ค่าน้ำ',
    photo: 'ชำระผ่านรูปถ่าย',
    life: 'จ่ายบิลรายเดือน',
    uploadFail: 'อัปโหลดล้มเหลว โปรดลองใหม่',
    pleaseFill: 'กรุณากรอกข้อมูลให้ครบถ้วน',
    submitSuccess: 'ส่งข้อมูลเรียบร้อย รอการชำระเงิน',
  },
  langPop: {
    selectLang: 'เลือกภาษา',
  },
  loginPop: {
    loginOrRegister: 'กรุณาเข้าสู่ระบบหรือสมัครสมาชิก Kuaizi',
    confirmLogout: 'คุณต้องการออกจากระบบหรือไม่?',
    toLogin: 'เข้าสู่ระบบ',
    logoutSuccess: 'ออกจากระบบเรียบร้อยแล้ว',
  },
  newMe: {
    myOrder: 'คำสั่งซื้อของฉัน',
    coupon: 'คูปอง',
    accountManage: 'จัดการบัญชี',
    orderCount: 'คำสั่งซื้อที่กำลังดำเนินการ',
    couponCount: 'ใบ',
    account: 'บัญชี',
    logout: 'ออกจากระบบ',
  },
  coupons: {
    all: 'ทั้งหมด',
    coupon: 'คูปอง',
    historyCoupon: 'คูปองที่หมดอายุ',
    use: 'ใช้ตอนนี้',
    validityPeriod: 'ช่วงเวลาที่ใช้ได้',
    useRule: 'เงื่อนไขการใช้',
    used: 'ใช้แล้ว',
    expired: 'หมดอายุ',
  },
  accountSeting: {
    title: 'ตั้งค่า',
    personalInfo: 'ข้อมูลส่วนตัว',
    modifyPayPassword: 'เปลี่ยนรหัสผ่านการชำระเงิน',
    modifyLoginPassword: 'เปลี่ยนรหัสผ่านเข้าสู่ระบบ',
    phone: 'เบอร์โทร',
    code: 'รหัสยืนยัน',
    loginPassword: 'รหัสผ่านเข้าสู่ระบบ',
    confirmModify: 'ยืนยันการเปลี่ยนแปลง',
    noCode: 'ไม่ได้รับรหัสยืนยัน?',
    passwordPlaceholder: 'รหัสผ่านต้องมี 8–16 ตัวอักษรและตัวเลข',
    inputCorrectPhone: 'กรอกเบอร์โทรให้ถูกต้อง',
    afterGetCode: 'รับใหม่ได้อีกครั้งภายหลัง',
    getCode: 'รับรหัส',
    input6DigitPassword: 'กรุณากรอกรหัส 6 หลัก',
    twoInputPasswordNotConsistent: 'รหัสผ่านไม่ตรงกัน',
    placeholderCode: 'กรุณากรอกรหัสยืนยัน',
    confirmPassword: 'ยืนยันรหัสผ่าน',
    password: 'รหัสผ่าน',
    submit: 'ส่ง',
    avatar: 'รูปโปรไฟล์',
    userName: 'ชื่อผู้ใช้',
    nickName: 'ชื่อเล่น',
    modifyPhone: 'แก้ไขหมายเลขโทรศัพท์',
    nickNamePlaceholder: 'เป็นคนที่มีตัวตน',
    sex: 'เพศ',
    male: 'ชาย',
    female: 'หญิง',
    email: 'อีเมล',
    emailPlaceholder: 'ตั้งค่าอีเมลเพื่อความสะดวกในการกู้คืนรหัสผ่าน',
    pleaseCompletePersonalData: 'กรุณากรอกข้อมูลส่วนตัวเพื่อใช้งานฟีเจอร์เพิ่มเติม',
    bindNewPhone: 'ผูกเบอร์ใหม่',
    oldPhone: 'เบอร์เดิม',
    completeVerification: 'ยืนยันตัวตนให้เสร็จสิ้น',
    changePayPasswordTitle: 'เปลี่ยนรหัสชำระเงิน',
    changePasswordTitle: 'เปลี่ยนรหัสผ่าน',
    oldPhoneTitle: 'ยืนยันเบอร์เดิม',
    editInfoTitle: 'แก้ไขข้อมูลส่วนตัว',
    areaCode: 'รหัสพื้นที่',
  },
}
